<template>
  <div
    class="flex-shrink-0 w-100 br-t-1px br-grey"
    :class="{
      'pd-micro': !stateSidebar,
      'pd-small': stateSidebar,
    }"
  >
    <!-- Skeleton while loading -->
    <Skeleton
      v-if="loading"
      :horizontal="true"
      :structure="[
        { block: 'avatar', size: 'small' },
      ]"
      class="radius-small pd-thin"
    />

    <!-- User card -->
    <router-link
      v-else-if="user?._id"
      :to="`/backoffice/users/${user._id}`"
      class="ease-quint-out flex w-100 radius-small cursor-pointer flex-nowrap"
      :class="[
        stateSidebar ? 'pd-thin flex-v-center' : 'w-100 flex-center',
        theme === 'light' ? 'bg-light hover:bg-grey' : 'bg-dark hover:bg-grey'
      ]"
    >
      <span class="aspect-1x1 flex-child-default w-max-big w-100 flex flex-center">
        <img
          v-if="user.profile?.photo"
          :src="(FILE_SERVER_URL || '') + user.profile.photo"
          class="radius-small bg-white object-fit-cover i-semi"
        />
        <PlaceholderUserpic
          v-else
          class="radius-small i-semi"
        />
      </span>

      <div
        v-if="stateSidebar"
        class="flex-child-default mn-l-thin o-hidden"
      >
        <p class="fw-medium mn-b-micro t-truncate ws-nowrap">{{ user.profile?.name || 'Anonymous' }}</p>
        <div class="flex flex-nowrap gap-micro">
          <span
            v-for="(role, index) in user.roles"
            :key="index"
            class="pd-thin radius-small p-small fw-semi bg-white ws-nowrap"
          >
            {{ role.icon }} {{ role.name }}
          </span>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue'

  import Skeleton from '@martyrs/src/design-system/components/Skeleton/Skeleton.vue'
  import PlaceholderUserpic from '@martyrs/src/modules/icons/placeholders/PlaceholderUserpic.vue'

  import * as auth from '@martyrs/src/modules/auth/views/store/auth.js'
  import * as users from '@martyrs/src/modules/auth/views/store/users.js'

  defineProps({
    theme: {
      type: String,
      default: 'light'
    },
    stateSidebar: {
      type: Boolean,
      default: false
    }
  })

  const loading = ref(true)
  const user = ref(null)

  onMounted(async () => {
    try {
      if (auth.state.user?._id) {
        await users.actions.read({ _id: auth.state.user._id })
        user.value = users.state.current
      }
    } catch (err) {
      console.error('Failed to load user:', err)
    } finally {
      loading.value = false
    }
  })
</script>
